var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-wrap"},[_c('div',{staticClass:"list-wrap"},[_c('im-list-message')],1),_c('div',{staticClass:"textarea-wrap"},[_c('im-textarea',{attrs:{"content":_vm.content}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }